/**
 * @generated SignedSource<<9305987b20e3633b08cace978fe34316>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RetroPGFResultsContainerFragment$data = {
  readonly retroPGF: {
    readonly applications: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"RetroPGFResultsContainerApplicationRowFragment">;
        };
      }>;
    };
  };
  readonly " $fragmentType": "RetroPGFResultsContainerFragment";
};
export type RetroPGFResultsContainerFragment$key = {
  readonly " $data"?: RetroPGFResultsContainerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RetroPGFResultsContainerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "retroPGF",
  "applications"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "category"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "alphabeticalAZ",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seed"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./RetroPGFResultsContainerPaginationQuery.graphql')
    }
  },
  "name": "RetroPGFResultsContainerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroPGF",
      "kind": "LinkedField",
      "name": "retroPGF",
      "plural": false,
      "selections": [
        {
          "alias": "applications",
          "args": [
            {
              "kind": "Variable",
              "name": "category",
              "variableName": "category"
            },
            {
              "kind": "Variable",
              "name": "orderBy",
              "variableName": "orderBy"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "search"
            },
            {
              "kind": "Variable",
              "name": "seed",
              "variableName": "seed"
            }
          ],
          "concreteType": "ProjectsConnection",
          "kind": "LinkedField",
          "name": "__RetroPGFResultsContainerFragment_applications_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Project",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RetroPGFResultsContainerApplicationRowFragment"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e479efe469eeddb45b50fb4f649eb7cb";

export default node;
